import { useTranslation } from '@framework/i18n';
import { Space } from 'antd';
import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { RoutePath } from '../RoutePaths';
import { useMainMenuItem } from './useMainMenuItem';

const MainMenuFrontWrapper = styled.nav`
  /* padding: 12px 0; */
`;

export interface MenuItemsProps {
  menuKey: string;
  to: RoutePath;
  children: React.ReactNode;
  /**  Titolo descrittivo dell'azione per Screen Reader */
  title?: string;
}

export interface IMainMenuProps {}
export function MainMenu(props: IMainMenuProps) {
  const { t } = useTranslation();

  const items = useMainMenuItem();

  return (
    <MainMenuFrontWrapper
      aria-label={t('main-menu.mobile.aria-label', 'Menu Principale')}
      id="main-menu"
    >
      <Space size={48} className="main-menu-wrapper-space">
        {items.map(item => (
          <NavLink
            key={item.menuKey}
            to={item.to}
            activeClassName="active"
            title={item.title}
          >
            {item.children}
          </NavLink>
        ))}
      </Space>
    </MainMenuFrontWrapper>
  );
}
